module.exports = __webpack_public_path__ + "static/preview-noon-1200x630.473822a6.jpg";